import Graticule from 'ol/layer/Graticule';
import VectorLayer from 'ol/layer/Vector';
import ImageLayer from 'ol/layer/Image';
import TileLayer from 'ol/layer/Tile';
import LayerGroup from 'ol/layer/Group';
import VectorSource from 'ol/source/Vector';
import ImageWMSSource from 'ol/source/ImageWMS';
import TileWMSSource from 'ol/source/TileWMS';
import OSM from 'ol/source/OSM';
import BingMaps from 'ol/source/BingMaps';

import GeoJSON from 'ol/format/GeoJSON.js';
import { bbox as bboxStrategy } from 'ol/loadingstrategy';
import Feature from 'ol/Feature';
import { fromExtent } from 'ol/geom/Polygon';
import { get as getProjection } from 'ol/proj';

import {
  styleGraticule,
  styleIdwm,
  styleLakes,
  styleSea,
  styleSites,
  styleUNMapSpratly,
  styleAssgnSpratly,
  styleAssgnSpratlyPending,
  //styleAssgnSpratlyTPR,
  styleCirafZones,
  styleUNMaps,
  styleCirafQuadrant,
  cloneStyle,
} from './olStyles';

import { filterLayers } from './utils.js';

import { hideLabels, setZIndexsOnLayers } from './maptoolkit.js';

import legendTerrain from '../assets/legend-osm.png';

const baseGeoserverURL = 'https://br-geoportal.itu.int/ITU-R/BR-Geo/';

const paramsJson = 'service=WFS&version=2.0.0&request=GetFeature&outputFormat=application%2Fjson&typeNames=';

const baseWebServerURL = 'https://br-terraweb-4.itu.int/ITU-R/eTerrestrial/data/';

//const extentSea = [-180, 0, 180, 90];


// The whole world in the map projection (EPSG:3857, in meters). Countries and lakes are drawn on top of it.
const seaPolygon = fromExtent(getProjection('EPSG:3857').getExtent());



const seaSource = new VectorSource({
  features: [new Feature(seaPolygon)],
});



const urls = {
  json: {
    idwm: baseGeoserverURL + 'wfs?' + paramsJson,
    un: baseGeoserverURL + 'wfs?' + paramsJson,
    disputed: baseGeoserverURL + 'AssgnInSpratly/wfs?' + paramsJson,//TOBE FIXED. NO LAYER
  },
  ti: {
    idwm: baseGeoserverURL + 'vector/wms',
    un: baseGeoserverURL + 'vector/wms',
  },
};
const format = 'image/png';

export const dictLayerNames = {
  graticule: { label: 'graticule', zIndex: 9998 },
  //Json
  hfbcSitesJson: { label: 'HFBC Sites (JSON)', zIndex: 29 },
  hfbcCirafZonesJson: { label: 'HFBC CIRAF zones (JSON)', zIndex: 20 },
  hfbcCirafQuadrantsJson: { label: 'HFBC CIRAF Quadrants (JSON)', zIndex: 21 },

  SpratlyJson: { label: 'Spratly Recorded (JSON)', zIndex: 23 },
  SpratlyPendingJson: { label: 'Spratly Pending (JSON)', zIndex: 24 },

  //UNMapSpratlyJson: { label: 'Spratly UNmaps (JSON)', zIndex: 26 },
  un11Json: { label: 'UNmap 1:1M (JSON)', zIndex: 15 },
  un15Json: { label: 'UNmap 1:5M (JSON)', zIndex: 16 },
  un125Json: { label: 'UNmap 1:25M (JSON)', zIndex: 17 },

  idwmJsonZip: { label: 'IDWM (JSON Zip)', zIndex: 12 },

  // //GeoServer json for IDWM
  seaJson: { label: 'sea (JSON)', zIndex: 10 },
  idwmJson: { label: 'IDWM (JSON)', zIndex: 11 },
  lakesJson: { label: 'Lakes (JSON)', zIndex: 12 },
  lakeslinesJson: { label: 'Lakes lines (JSON)', zIndex: 13 },

  //Geoserver/ Web server jsons for IDWM Group
  seaJsonLocal: { label: 'sea (JSON)', zIndex: 10 },
  idwmJsonLocal: { label: 'IDWM (JSON)', zIndex: 11 },
  lakesJsonLocal: { label: 'Lakes (JSON)', zIndex: 12 },
  lakeslinesJsonLocal: { label: 'Lakes lines (JSON)', zIndex: 13 },

  // Groups
  idwmGroup: { label: 'IDWM (Group)', zIndex: 9 },
  idwmGroupWebServer: { label: 'IDWM (Group Web Server)', zIndex: 9 },
  //Tiles
  idwmTile: { label: 'IDWM (Tile)', zIndex: 12 },
  lakesTile: { label: 'Lakes (Tile)', zIndex: 13 },
  un11Tile: { label: 'UNmap 1:1M (Tile)', zIndex: 15 },
  un15Tile: { label: 'UNmap 1:5M (Tile)', zIndex: 16 },
  un125Tile: { label: 'UNmap 1:25M (Tile)', zIndex: 17 },
  //Images
  idwmImage: { label: 'IDWM (Image)', zIndex: 12 },
  lakesImage: { label: 'Lakes (Image)', zIndex: 13 },
  un11Image: { label: 'UNmap 1:1M (Image)', zIndex: 15 },
  un15Image: { label: 'UNmap 1:5M (Image)', zIndex: 16 },
  un125Image: { label: 'UNmap 1:25M (Image)', zIndex: 17 },
  // Basemaps
  osm: { label: 'OpenStreetMap (OSM)', zIndex: 0 },
  terrain: { label: 'Terrain', zIndex: 1 },
  bingRoads: { label: 'Bing (Roads)', zIndex: 4 },
  bingAerial: { label: 'Bing (Aerial)', zIndex: 2 },
  bingAerialLabels: { label: 'Bing (Aerial with labels)', zIndex: 3 },
};

function getSourceJson(url) {
  let source = new VectorSource({
    format: new GeoJSON(),
    url: url,
    strategy: bboxStrategy,
  });
  return source;
}

function getSourceTile(url, layers) {
  let tilesOrigin = -180.00000543699997 + ',' + -89.90000152599998;
  let source = new TileWMSSource({
    url: url,
    params: {
      FORMAT: format,
      VERSION: '1.1.1',
      tiled: true,
      LAYERS: layers,
      exceptions: 'application/vnd.ogc.se_inimage',
      tilesOrigin: tilesOrigin,
    },
  });
  return source;
}

function getSourceImage(url, layers) {
  let source = new ImageWMSSource({
    ratio: 1,
    url: url,
    params: {
      FORMAT: format,
      VERSION: '1.1.1',
      STYLES: '',
      LAYERS: layers,
      exceptions: 'application/vnd.ogc.se_inimage',
    },
  });
  return source;
}

function getSourceIdwmJsonZip() {
  const jsonFileName = 'idwm_2025';
  const url = '../assets/' + jsonFileName + '.zip';
  const source = new VectorSource({
    format: new GeoJSON(),
    url: url,
    loader: () => {
      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error('HTTP error ' + response.status);
          }
          return response.blob();
        })
        .then((blob) => {
          JSZip.loadAsync(blob).then((zip) => {
            zip
              .file(jsonFileName + '.json')
              .async('string')
              .then((contents) => {
                const geojson = JSON.parse(contents);
                const features = source.getFormat().readFeatures(geojson);
                source.addFeatures(features);
              });
          });
        });
    },
  });
  return source;
}

export function getAvailablelayers(isGeoServerAvailable, isProd) {
  let keyBing = 'AneQfdj4THRdo_NmmHrZWAz6XpjdFHN8vZ8Dq7evedE1x0ASCff_Fz-cDGCKOTbh';
  let layersFromGeoServer = {
    //Json
    hfbcSitesJson: new VectorLayer({
      visible: true,
      labels: true,
      name: dictLayerNames['hfbcSitesJson'].label,
      zIndex: dictLayerNames['hfbcSitesJson'].zIndex,
      source: getSourceJson(urls.json.idwm + 'vector:HFBCsites'),
      style: styleSites,
      styleOrigin: cloneStyle(styleSites),
      server: 'geo',
      hasLabels: true,
    }),
    hfbcCirafZonesJson: new VectorLayer({
      labels: true,
      visible: true,
      name: dictLayerNames['hfbcCirafZonesJson'].label,
      zIndex: dictLayerNames['hfbcCirafZonesJson'].zIndex,
      source: getSourceJson(urls.json.idwm + 'vector:HFBC_CIRAF_zones'),
      style: styleCirafZones,
      styleOrigin: cloneStyle(styleCirafZones),
      server: 'geo',
      hasLabels: true,
    }),

    hfbcCirafQuadrantsJson: new VectorLayer({
      labels: false,
      visible: true,
      name: dictLayerNames['hfbcCirafQuadrantsJson'].label,
      zIndex: dictLayerNames['hfbcCirafQuadrantsJson'].zIndex,
      source: getSourceJson(urls.json.idwm + 'vector:HFBC_CIRAF_quadrants'),
      style: styleCirafQuadrant,
      styleOrigin: cloneStyle(styleCirafQuadrant),
      server: 'geo',
      hasLabels: true,
    }),
    //Json

    // UNMapSpratlyJson: new VectorLayer({
    //   visible: true,
    //   labels: true,
    //   name: dictLayerNames['UNMapSpratlyJson'].label,
    //   zIndex: dictLayerNames['UNMapSpratlyJson'].zIndex,
    //   source: getSourceJson(urls.json.disputed + 'AssgnInSpratly%3Aislands'),
    //   style: styleUNMapSpratly,
    //   styleOrigin: cloneStyle(styleUNMapSpratly),
    //   server: 'geo',
    //   hasLabels: true,
    // }),

    // SpratlyJson: new VectorLayer({
    //   visible: true,
    //   labels: true,
    //   name: dictLayerNames['SpratlyJson'].label,
    //   zIndex: dictLayerNames['SpratlyJson'].zIndex,
    //   source: getSourceJson(urls.json.disputed + 'AssgnInSpratly%3ASpratlyRecorded'),
    //   style: styleAssgnSpratly,
    //   styleOrigin: cloneStyle(styleAssgnSpratly),
    //   server: 'geo',
    //   hasLabels: true,
    // }),

    // SpratlyPendingJson: new VectorLayer({
    //   visible: true,
    //   labels: true,
    //   name: dictLayerNames['SpratlyPendingJson'].label,
    //   zIndex: dictLayerNames['SpratlyPendingJson'].zIndex,
    //   source: getSourceJson(urls.json.disputed + 'AssgnInSpratly%3ASpratlyPending'),
    //   style: styleAssgnSpratlyPending,
    //   styleOrigin: cloneStyle(styleAssgnSpratlyPending),
    //   server: 'geo',
    //   hasLabels: true,
    // }),
    // SpratlyAssgnSpratlyTPRJson: new VectorLayer({
    //   visible: true,
    //   labels: true,
    //   name: dictLayerNames['SpratlyAssgnSpratlyTPRJson'].label,
    //   zIndex: dictLayerNames['SpratlyAssgnSpratlyTPRJson'].zIndex,
    //   source: getSourceJson(urls.json.disputed + 'AssgnInSpratly%3AassgnInSpratlyTPR'),
    //   style: styleAssgnSpratlyTPR,
    //   styleOrigin: cloneStyle(styleAssgnSpratlyTPR),
    //   server: 'geo',
    //   hasLabels: true,
    // }),
    idwmGroup: new LayerGroup({
      name: dictLayerNames['idwmGroup'].label,
      zIndex: dictLayerNames['idwmGroup'].zIndex,
      server: 'geo',
      hasLabels: true,
      layers: [
        new VectorLayer({
          labels: true,
          visible: true,
          name: dictLayerNames['idwmJson'].label,
          zIndex: dictLayerNames['idwmJson'].zIndex,
          source: getSourceJson(urls.json.idwm + 'vector:idwm'),
          style: styleIdwm,
          styleOrigin: cloneStyle(styleIdwm),
        }),
        new VectorLayer({
          labels: false,
          visible: true,
          name: dictLayerNames['lakesJson'].label,
          zIndex: dictLayerNames['lakesJson'].zIndex,
          source: getSourceJson(urls.json.idwm + 'vector:idwm_lakes'),
          style: styleLakes,
          styleOrigin: cloneStyle(styleLakes),
        }),
        new VectorLayer({
          labels: false,
          visible: true,
          name: dictLayerNames['lakeslinesJson'].label,
          zIndex: dictLayerNames['lakeslinesJson'].zIndex,
          source: getSourceJson(urls.json.idwm + 'vector:idwm_lakes_lines'),
          style: styleLakes,
          styleOrigin: cloneStyle(styleLakes),
        }),
         new VectorLayer({
           labels: false,
           visible: true,
           name: dictLayerNames['seaJson'].label,
           zIndex: dictLayerNames['seaJson'].zIndex,
        //   source: getSourceJson(urls.json.idwm + 'vector%3Asea'),
            source: seaSource,
           style: styleSea,
           styleOrigin: cloneStyle(styleSea),
         }),
      ],
    }),
    //Images //the following one is the Group!!!!! there was no need to build up the json group :-(
    idwmImage: new ImageLayer({
      labels: true,
      visible: true,
      name: dictLayerNames['idwmImage'].label,
      zIndex: dictLayerNames['idwmImage'].zIndex,
      source: getSourceImage(urls.ti.idwm, 'idwm_all'),
      server: 'geo',
    }),
    un11Image: new ImageLayer({
      visible: true,
      name: dictLayerNames['un11Image'].label,
      zIndex: dictLayerNames['un11Image'].zIndex,
      source: getSourceImage(urls.ti.un, 'bnda_cty'),
      server: 'geo',
    }),
    un15Image: new ImageLayer({
      visible: true,
      name: dictLayerNames['un15Image'].label,
      zIndex: dictLayerNames['un15Image'].zIndex,
      source: getSourceImage(urls.ti.un, 'bnda05_cty'),
      server: 'geo',
    }),
    un125Image: new ImageLayer({
      visible: true,
      name: dictLayerNames['un125Image'].label,
      zIndex: dictLayerNames['un125Image'].zIndex,
      source: getSourceImage(urls.ti.un, 'bnda25_cty'),
      server: 'geo',
    }),
  };

  let layersFromWebServer = {
    idwmGroupWebServer: new LayerGroup({
      name: dictLayerNames['idwmGroupWebServer'].label,
      zIndex: dictLayerNames['idwmGroupWebServer'].zIndex,
      server: 'web',
      hasLabels: true,
      layers: [
        new VectorLayer({
          labels: true,
          visible: true,
          name: dictLayerNames['idwmJsonLocal'].label,
          zIndex: dictLayerNames['idwmJsonLocal'].zIndex,
          source: getSourceJson(baseWebServerURL + 'idwm_2025.json'),
          style: styleIdwm,
          styleOrigin: cloneStyle(styleIdwm),
        }),
        new VectorLayer({
          labels: false,
          visible: true,
          zIndex: dictLayerNames['lakesJsonLocal'].zIndex,
          source: getSourceJson(baseWebServerURL + 'idwm_lakes.json'),
          style: styleLakes,
          styleOrigin: cloneStyle(styleLakes),
        }),
        new VectorLayer({
          labels: false,
          visible: true,
          zIndex: dictLayerNames['lakeslinesJsonLocal'].zIndex,
          source: getSourceJson(baseWebServerURL + 'idwm_lakes_lines.json'),
          style: styleLakes,
          styleOrigin: cloneStyle(styleLakes),
        }),
        new VectorLayer({
          labels: false,
          visible: true,
          zIndex: dictLayerNames['seaJsonLocal'].zIndex,
          source: getSourceJson(baseWebServerURL + 'sea.json'),
          style: styleSea,
          styleOrigin: cloneStyle(styleSea),
        }),
      ],
    }),
  };

  let basemapsFree = {
    //Basemaps
    osm: new TileLayer({
      visible: true,
      name: dictLayerNames['osm'].label,
      zIndex: dictLayerNames['osm'].zIndex,
      source: new OSM(),
      server: 'baseMaps',
    }),
    terrain: new TileLayer({
      visible: true,
      name: dictLayerNames['terrain'].label,
      zIndex: dictLayerNames['terrain'].zIndex,
      opacity: 0.7,
      source: new TileWMSSource({
        url: 'https://ows.terrestris.de/osm/service',
        params: {
          LAYERS: 'TOPO-WMS',
          TILED: 'true',
          VERSION: '1.1.1',
        },
      }),
      server: 'baseMaps',
      legend: legendTerrain,
    }),
  };

  // let bingMaps = {
  //   bingRoads: new TileLayer({
  //     visible: true,
  //     name: dictLayerNames['bingRoads'].label,
  //     zIndex: dictLayerNames['bingRoads'].zIndex,
  //     preload: Infinity,
  //     source: new BingMaps({
  //       imagerySet: 'RoadOnDemand',
  //       key: keyBing,
  //     }),
  //     server: 'baseMaps',
  //   }),
  //   bingAerial: new TileLayer({
  //     visible: true,
  //     name: dictLayerNames['bingAerial'].label,
  //     zIndex: dictLayerNames['bingAerial'].zIndex,
  //     preload: Infinity,
  //     source: new BingMaps({
  //       imagerySet: 'Aerial',
  //       key: keyBing,
  //     }),
  //     server: 'baseMaps',
  //   }),
  //   bingAerialLabels: new TileLayer({
  //     visible: true,
  //     name: dictLayerNames['bingAerialLabels'].label,
  //     zIndex: dictLayerNames['bingAerialLabels'].zIndex,
  //     preload: Infinity,
  //     source: new BingMaps({
  //       imagerySet: 'AerialWithLabelsOnDemand',
  //       key: keyBing,
  //     }),
  //     server: 'baseMaps',
  //   }),
  // };

  let layers = {
    graticule: new Graticule({
      visible: true,
      name: dictLayerNames['graticule'].label,
      zIndex: dictLayerNames['graticule'].zIndex, //Always on top
      strokeStyle: styleGraticule,
      showLabels: true,
      wrapX: false,
    }),
  };

  //add the layers from GeoServer if available or the local ones
  if (isGeoServerAvailable) {
    includeLayers(layersFromGeoServer, layers);
  } else {
    includeLayers(layersFromWebServer, layers);
  }

  includeLayers(basemapsFree, layers);
  // if (!isProd) {
  //   includeLayers(bingMaps, layers);
  // }
  Object.entries(layers).forEach((entry) => {
    let [key, layer] = entry;
    layer.set('hasDeleteBtn', true);
  });

  //should filter in case there are initial options for the layers to be added?

  return layers;
}

export function getAvailablelayerByKey(isGeoServerAvailable, isProd, layerKey) {
  let olAvailableLayers = getAvailablelayers(isGeoServerAvailable, isProd);
  let layer = olAvailableLayers[layerKey];
  return layer;
}

function includeLayers(source, dest) {
  Object.entries(source).forEach((entry) => {
    let [key, value] = entry;
    dest[key] = value;
  });
}

export function getInitLayers({ layers, isGeoServerAvailable, isProd }) {
  const olAvailableLayers = getAvailablelayers(isGeoServerAvailable, isProd);
  const availableKeys = Object.keys(olAvailableLayers);

  let defaultLayers = [];
  let haslayers = layers && layers.length;

  if (isGeoServerAvailable) {
    defaultLayers = haslayers ? layers : ['idwmGroup'];
  } else {
    if (haslayers) {
      layers.forEach((layer) => {
        if (typeof layer === 'object') {
          if (layer.hasOwnProperty('name')) {
            let name = layer['name'];
            if (name == 'idwmGroup') {
              layer['name'] = 'idwmGroupWebServer';
            }
            defaultLayers.push(layer);
          }
        } else {
          if (layer == 'idwmGroup') {
            defaultLayers.push('idwmGroupWebServer');
          } else {
            defaultLayers.push(layer);
          }
        }
      });
      defaultLayers = defaultLayers.filter((layer) => {
        const name = typeof layer === 'object' ? layer.name : layer;
        return availableKeys.includes(name);
      });
    } else {
      defaultLayers = ['idwmGroupWebServer'];
    }
  }

  let olLayers = filterLayers(olAvailableLayers, defaultLayers);

  let graticule = olAvailableLayers?.graticule;
  if (graticule) {
    olLayers.unshift(graticule);
  }

  let order = olLayers.map((layer) => layer.get('name'));

  setZIndexsOnLayers(olLayers, order);

  return olLayers;
}

export async function getFeauresFromJson(layerKey) {
  try {
    let layer = getAvailablelayerByKey(true, true, layerKey);
    let source = layer.getSource();
    if (typeof source.getUrl === 'function') {
      let url = source.getUrl();
      if (url) {
        const response = await fetch(url);
        const data = await response.json();
        const format = new GeoJSON();
        const features = format.readFeatures(data, {
          featureProjection: 'EPSG:4326',
        });
        const points = features
          .filter((feature) => feature.getGeometry().getType() === 'Point')
          .map((feature) => {
            let coords = feature.getGeometry().getCoordinates();
            let props = feature.getProperties(); // Get all properties (attributes)
            delete props.geometry;
            return {
              long: coords[0],
              lat: coords[1],
              props,
            };
          });
        return points;
      }
    }
  } catch (error) {
    console.error('Error fetching or parsing the GeoJSON ' + layerKey + ':', error);
  }
}
